import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { BUTTON, COMMON_TEXT, DpadKeyCode, DpadZoneType } from '@core/constants';
import { DpadZoneState } from '@core/models/models';
import { DpadControlService } from '@core/services/common/dpad-control.service';
import { Subscription } from 'rxjs';

interface OptionItem {
  name: string;
  value: any;
}

@Component({
  selector: 'caremoni-tv-multiselect',
  templateUrl: './multi-select-box-tv.component.html',
  styleUrls: ['./multi-select-box-tv.component.scss']
})
export class MultiSelectBoxTvComponent implements OnInit, OnDestroy, AfterViewChecked  {
  @Input() options: OptionItem[] = [];
  @Input() selectedValues: any[] = [];
  @Output() valueChange = new EventEmitter<any[]>();
  @ViewChild('dialogmuti') dialogmuti!: ElementRef;

  @Input() xdpad?: number = -1;
  @Input() ydpad?: number = -1;
  @Input() dpad?: number = -1;
  @Input() tabdpad?: number = -1;
  @Input() xtabdpad?: number = -1;
  @Input() ytabdpad?: number = -1;
  @Input() scaledpad?: number = -1;

  @Input() id?: string;
  @Input() disabled = false;
  @Input() isReset = false;
  @Input() placeholder = '';

  dialogVisible = false;
  afterViewInitDialog = false;
  currentZone: number = DpadZoneType.TV_POPUP_MULTI_SELECT;
  subscription: Subscription = new Subscription();
  displaySelected:string = "";
  BUTTON = BUTTON;
  COMMON_TEXT = COMMON_TEXT;

  constructor(
      private dpadControlService: DpadControlService,
      private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.dpadSbr();
  }

  async openDialog() {
    if (this.disabled) return;
    this.dialogVisible = true;
    await this.dpadControlService.initMultiSelectPopup();
  }

  closeDialog() {
    this.dialogVisible = false;
    this.afterViewInitDialog = false;
    let dZone = {
      dType: this.dpad || DpadZoneType.SCREEN,
      dXMin: DpadZoneType.DEFAULT,
      dXMax: DpadZoneType.TV_USER_SETTINGS_MID,
      dYMin: DpadZoneType.DEFAULT,
      dYMax: DpadZoneType.TV_LAYOUT
    }
    this.dpadControlService.goToZone(this.dpad, this.xdpad, this.ydpad, dZone);
  }

  toggleValue(val: any) {
    const idx = this.selectedValues.indexOf(val);
    if (idx >= 0) {
      this.selectedValues = this.selectedValues.filter(v => v !== val);
    } else {
      this.selectedValues = [...this.selectedValues, val];
    }
  }

  onOk() {
    this.valueChange.emit(this.selectedValues);
    this.closeDialog();
  }

  onCancel() {
    this.closeDialog();
  }

  dpadSbr(){
    [
      this.dpadControlService.dZoneState$.subscribe((state: DpadZoneState) => {
        if(state.dKey == DpadKeyCode.KEYCODE_BACK && state.dZone == this.currentZone && this.dialogVisible) {
          this.onOk();
        }
      })
    ].forEach(sub => this.subscription.add(sub));
  }

  ngOnDestroy(): void { 
    this.subscription.unsubscribe(); 
  }

  async ngAfterViewChecked(): Promise<void> {
    if(this.dialogVisible && this.dialogmuti && !this.afterViewInitDialog)
    {
      await this.dpadControlService.initMultiSelectPopup();
      this.afterViewInitDialog = true;
    }    
  }
}